import axios from "axios";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { FaSpinner, FaUserShield } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import stringToColor from "string-to-color";
import api from "../api";
import { ITeam } from "../api/services/team.service";
import UrlCopyElement from "./shared/UrlCopyElement";

export function getTags(team: ITeam) {
  return (
    <div className="flex space-x-4">
      {/* <StatusBadge
        key={"onboard"}
        status={"ONBOARD"}
        color={team.onboarded ? "green" : "red"}
      />
      <StatusBadge
        key={"verified"}
        status={"VERIFIED"}
        color={team.verified ? "green" : "red"}
      />
      <StatusBadge
        key={"deactivated"}
        status={"DEACTIVATED"}
        color={team.deactivated ? "green" : "red"}
      /> */}
    </div>
  );
}

export default function TeamProfileSection() {
  let { teamId } = useParams();

  const [team, setTeam] = useState<ITeam | null>(null);
  // const [insight, setInsight] = useState<ITeamInsight | null>(null);
  // const [insights, setInsights] = useState<ITeamInsight[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (teamId) {
      setLoading(true);
      fetchTeam(teamId);
      // fetchTeamInsights(teamId);
    }
  }, [teamId]);

  async function fetchTeam(teamId: string) {
    try {
      setLoading(true);
      const { data } = await api.team.getTeam(teamId);
      if (data.result) {
        setTeam(data.result);

        setLoading(false);
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  // async function fetchTeamInsights(teamId: string) {
  //   try {
  //     const { data } = await api.team.getTeamInsights(teamId);
  //     if (data.result) {
  //       setInsights(data.result);
  //     }
  //   } catch (e) {
  //     if (axios.isAxiosError(e)) {
  //       if (e.response?.data) {
  //         if (e.response?.status !== 404) {
  //           toast.error(e.response?.data.errorMessage);
  //         }
  //       }
  //     } else {
  //       console.log(e);
  //       toast.error(
  //         "Something really went wrong, you might want to contact support!"
  //       );
  //     }
  //   }
  // }

  return (
    <div className="flex flex-col rounded-2xl shadow-xl bg-white grow overflow-hidden">
      <div className="flex items-center p-4 w-full border-b justify-between">
        <div className="flex items-center">
          <div className="flex items-center mr-10 rounded-lg">
            <div className="">
              <FaUserShield size={20} className="text-red-700" />
            </div>
            <span className="ml-2 font-medium leading-6 text-slate-700 text-lg flex items-center">
              {!loading && team !== null && (
                <span className="ml-2 text-slate-700">{team.name}</span>
              )}
            </span>
          </div>
        </div>
        <div className=""></div>
      </div>
      {loading && (
        <div className="flex items-center justify-center p-20 text-slate-500">
          <FaSpinner size={30} className="animate-spin" />
        </div>
      )}
      {!loading && team !== null && (
        <div>
          <div className="px-3 md:px-4 py-5 sm:px-6 flex space-x-4 bg-slate-100">
            <FaUserShield
              className="bg-white rounded-full h-12 w-12"
              color={stringToColor(team.id)}
            />
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Team Information
              </h3>
              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                Personal details and usage.
              </p>
            </div>
          </div>
          <div className="">
            <dl>
              <div className="bg-white px-3 md:px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Label name
                </dt>
                <dd className="mt-1 text-sm font-medium text-gray-900 sm:mt-0 sm:col-span-2">
                  {team.name}
                </dd>
              </div>
              <div className="bg-slate-100 px-3 md:px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Don't know
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  <UrlCopyElement url={"-nothing-"} />
                </dd>
              </div>
              <div className="bg-white px-3 md:px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">PrimaryId</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  <UrlCopyElement url={team.id} />
                </dd>
              </div>
              <div className="bg-slate-100 px-3 md:px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Registered At
                </dt>
                <dd className="mt-1 text-sm font-semibold text-gray-900 sm:mt-0 sm:col-span-2">
                  {format(new Date(team.createdAt), "dd.MM.yyyy HH:mm:ss")}
                </dd>
              </div>

              {/* {insights.map((insight, index) => {
                return (
                  <div className="bg-white px-3 md:px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Insight - {insight.type}
                    </dt>
                    <dd className="flex flex-col md:flex-row mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {insight &&
                        insight.type === "ABOUT" &&
                        printInsights_ABOUT(insight)}
                      {insight &&
                        insight.type === "AD_PARAMS" &&
                        printInsights_AD_PARAMS(insight)}
                      {insight &&
                        insight.type === "BROWSER_PARAMS" &&
                        printInsights_BROWSER(insight)}
                      {!insight && (
                        <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 font-semibold bg-slate-300 justify-center rounded px-2.5 py-0.5 text-sm h-6">
                          Insights Not Set
                        </div>
                      )}
                    </dd>
                  </div>
                );
              })} */}
              {/* {insights.length === 0 && (
                <div className="bg-white px-3 md:px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Insight</dt>
                  <dd className="flex flex-col md:flex-row mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 font-semibold bg-slate-300 justify-center rounded px-2.5 py-0.5 text-sm h-6 ">
                      Insights Not Set
                    </div>
                  </dd>
                </div>
              )} */}

              {/* <div className="bg-slate-100 px-3 md:px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Tags</dt>
                <dd className="flex flex-col md:flex-row mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {getTags(team)}
                </dd>
              </div> */}
              {/* <div className="bg-white px-3 md:px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Auth Provider
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {geztProvider(team)}
                </dd>
              </div> */}
            </dl>
          </div>
        </div>
      )}
      {!loading && team === null && (
        <div className="flex flex-col items-center justify-center p-8 text-slate-500">
          <div className="font-semibold text-slate-700 mb-2">
            Team Not Found
          </div>
          <div className="inline-flex items-center space-x-2">
            <div>Team not found...</div>
          </div>
        </div>
      )}
    </div>
  );
}
